import { render, staticRenderFns } from "./AddAndUpdate.vue?vue&type=template&id=78adef0c&scoped=true&"
import script from "./AddAndUpdate.vue?vue&type=script&lang=js&"
export * from "./AddAndUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AddAndUpdate.vue?vue&type=style&index=0&id=78adef0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78adef0c",
  null
  
)

export default component.exports